<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>用户订单数据</span>
        </div>

        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="开始日期" prop="title">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              style="width: 150px;"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item label="结束日期" prop="title">
            <el-date-picker
              v-model="queryParams.endDate"
              style="width: 150px;"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item label="用户ID" prop="id">
            <el-input
              v-model="queryParams.id"
              placeholder="请输入用户ID"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="SKU" prop="sku">
            <el-input
              v-model="queryParams.sku"
              style="width: 220px;"
              placeholder="请输入SKU"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="订单号" prop="lang">
            <el-input
              v-model="queryParams.lang"
              style="width: 220px;"
              placeholder="请输入订单号"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button :loading="loading" type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
            <el-button icon="el-icon-refresh" :loading="loading" size="mini" @click="exportData">导出</el-button>
          </el-form-item>
        </el-form>

        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            label="类型"
            align="center"
          >
            <template v-slot:default="{row}">
              {{ typeArr[row['t']] }}
            </template>
          </el-table-column>
          <el-table-column
            prop="date"
            label="时间"
            align="center"
          />
          <el-table-column
            prop="uid"
            label="用户ID"
            align="center"
          />
          <el-table-column
            prop="title"
            label="商品"
            align="center"
          >
            <template v-slot:default="{row}">
              <span v-if="row.title == '未匹配到'">{{ row.gid }}</span>
              <span v-else>{{ row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sku"
            label="sku"
            align="center"
            width="180"
          />
          <el-table-column
            prop="extra"
            label="extra"
            align="center"
            width="180"
          />
          <el-table-column
            prop="param"
            label="请求参数"
            align="center"
            width="180"
            show-overflow-tooltip
          >
            <template v-slot:default="{row}">
              <span @click="viewParam(row.param)">{{ row.param }}</span>
            </template>

          </el-table-column>
          <el-table-column
            prop="no"
            label="订单号"
            align="center"
            width="180"
          />
          <el-table-column
            prop="result"
            label="结果"
            align="center"
          />
        </el-table>
      </el-card>
      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="30%"
      >
        <span>{{ textInfo }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </template>
  </BasicLayout>
</template>

<script>
import { getUserOrderProcessData } from '@/api/config/reward-record'
export default {
  name: 'UserOrderProcessData',
  data() {
    return {
      textInfo: '',
      dialogVisible: false,
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        id: '',
        startDate: '',
        sku: '',
        lang: '',
        level: 0
      },
      typeArr: { '1': '创建订单', '2': '拉起支付', '3': '订单状态', '4': '请求发货', '5': '发货状态' },
      loading: false,
      tableData: []
    }
  },
  created() {

  },
  methods: {
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      if (this.queryParams.lang === '') {
        if (this.queryParams.startDate === '') {
          this.msgError('请选择开始日期')
          return
        }
        if (this.queryParams.endDate === '') {
          this.msgError('请选择结束日期')
          return
        }
        if (this.queryParams.id === '') {
          this.msgError('请输入用户UID')
          return
        }
      }

      this.getTables()
    },
    getTables() {
      this.queryParams.level = 0
      this.loading = true
      getUserOrderProcessData(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      this.loading = true
      this.queryParams.level = 1
      getUserOrderProcessData(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    viewParam(param) {
      console.log('param', param)
      this.textInfo = param
      this.dialogVisible = true
    },
    copyText(textToCopy) {
      const input = document.createElement('textarea')
      input.style.position = 'fixed'
      input.style.opacity = '0'
      input.value = textToCopy
      document.body.appendChild(input)
      input.focus()
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('拷贝成功')
    }
  }
}
</script>

<style scoped>
</style>
